<template>
	<div class="page flex-col">
		<div class="group_11 flex-col">
			<div class="box_4 flex-row justify-between">
				<span class="text_3">{{ system }}</span>
				<span class="time">{{ time }}</span>
				<span class="day">{{ date }}</span>
				<span class="xq">{{ week }}</span>
			</div>
			<div class="box_8 flex-row">
				<!-- 第一个 -->
				<div class="block_6 flex-col">
					<div class="group_24 flex-col">
						<span class="text_371">电子围栏</span>
						<div class="section_14 flex-row" style="flex-wrap: wrap; gap: 10px">
							<div v-for="(item, index) in safe" :key="index"
								style=" flex: 0 0 calc(50% - 5px); display: flex;align-items: center;margin-bottom: 10px">
								<div class="box_21" style="flex-shrink: 0;">
									<img referrerpolicy="no-referrer" src="../assets/screen/img/users.gif"
										style="width: 80px; height: 80px">
								</div>
								<span class="text_9" style="margin-left: 8px;white-space: nowrap">
									{{item.name}}&nbsp;&nbsp;{{item.number}} 人
								</span>
							</div>
						</div>
					</div>
				</div>

				<!-- 第一排中间 -->
				<div class="block_4">

					<div class="box_38 flex-col">
						<span class="text_37">今日实到人数:<span class="number-box">{{attendanceCountAll}}</span>人</span>
						<span class="text_37">&nbsp;&nbsp;&nbsp;&nbsp;全园人数:<span
								class="number-box">{{studentCountAll}}</span>人</span>
						<div class="group_50 flex-col">
							<div class="group_421 flex-col">
								<div class="section_21 flex-col">
									<div class="water_order">
										<div class="water" :style="'top:' +'%;background: #E5E5E5;'">
										</div>
									</div>
									<div class="box_40 flex-col">
										<div class="text-wrapper_8">
											<span class="text_38">出勤率</span>
											<span class="text_40">{{attendanceRate}}</span>
										</div>
									</div>
								</div>
								<span class="text_40"></span>
							</div>
						</div>
					</div>
				</div>

				<div class="block_6_right flex-col">
					<div class="group_24 flex-col">
						<span class="text_371">兴趣分析</span>
						<div class="section_14 flex-row" style="flex-wrap: wrap; gap: 10px">
							<div v-for="(item, index) in xingqu" :key="index"
								style=" flex: 0 0 calc(50% - 5px); display: flex;align-items: center;margin-bottom: 10px">
								<div class="box_21" style="flex-shrink: 0;">
									<img referrerpolicy="no-referrer" src="../assets/screen/img/users.gif"
										style="width: 80px; height: 80px">
								</div>
								<span class="text_9" style="margin-left: 8px;white-space: nowrap">
									{{item.name}}&nbsp;&nbsp;{{item.number}} 人
								</span>
							</div>
						</div>
					</div>
				</div>

			</div>
			<div class="box_26 flex-col">
				<div class="section_17 flex-row">
					<div class="box_34 flex-col">
						<span class="text_33">各班级今日考勤统计</span>
						<div class="box_35 flex-row">
							<div :style="{width: '100%', height: '100%'}" ref="studentDay"></div>
						</div>
					</div>

					<div class="box_41">
						<span class="text_361">体温异常人数</span>
						<div class="box_39 flex-col">
							<div class="group_422 flex-col">
								<div class="section_22 flex-col">
									<div class="water_order">
										<div class="water" :style="'top:' +';background: #E5E5E5;'">
										</div>
									</div>
									<div class="box_40 flex-col">
										<div class="text-wrapper_8">
											<span class="text_39">{{screen.tempAlarm}}人</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>

			<div class="box_26 flex-col">
				<div class="section_17 flex-row">
					<div class="box_34 flex-col">
						<span class="text_33">各班级本月缺勤统计</span>
						<div class="box_351 flex-row justify-between">
							<div :style="{width: '100%', height: '100%'}" ref="studentMonth"></div>
						</div>
					</div>

					<div class="box_412 flex-col">
						<span class="text_36">心率异常人数</span>
						<div class="group_43 flex-col">
							<div class="block_12 flex-col">
								<div class="section_22 flex-col">
									<div class="water_order">
										<div class="water" :style="'top:' +'%;background: #E5E5E5;'"></div>
									</div>
									<div class="box_40 flex-col">
										<div class="text-wrapper_8">
											<span class="text_39">{{screen.heartRateAlarm}}人</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>



			</div>

		</div>
	</div>
</template>
<script>
	import data from "@/model/data";

	function init() {
		const _el = document.getElementById('app');
		const hScale = window.innerHeight / 1080;
		const wScale = window.innerWidth / 1920;
		_el.style.transform = 'scale(' + wScale + ',' + hScale + ')'
	}

	init();
	// 将事件侦听器函数附加到窗口的resize事件
	window.addEventListener("resize", init);
	import echarts from '../utils/echarts'
	import tool from "@/utils/tool";

	export default {
		data() {
			return {
				xingqu: [],
				safe: [],
				attendanceCountListName: [],
				attendanceCountListValue: [],
				studentCountAll: 0,
				attendanceCountAll: 0,
				attendanceRate: '',
				screen: {
					tempAlarm: 0,
					heartRateAlarm: 0,
					blood: {},
					oxygen: {},
					temp: {},
					sleep: {},
				},
				time: '',
				date: '',
				week: '',
				mapData: {},
				system: ''
			};
		},
		computed: {
			alarmImei() {
				this.mapData.map.forEach(v => {
					if (v.imei === this.$store.state.alarm_imei) {
						this.handleInfo(v)
					}
				})
				return this.$store.state.alarm_imei
			}
		},
		mounted() {
			this.loadData()
			this.system = tool.isEmpty(tool.getLocalStorage("client_name")) ? '智能手环管理系统' : tool.getLocalStorage(
				"client_name")
		},
		methods: {
			async loadData() {
				const ret = await data.screen({})
				this.screen = ret.data
				this.xingqu = ret.data.xingqu
				this.safe = ret.data.safe
				this.attendanceCountListName = ret.data.attendanceCountListName
				this.attendanceCountListValue = ret.data.attendanceCountListValue
				this.studentCountAll = ret.data.studentCountAll
				this.attendanceCountAll = ret.data.attendanceCountAll
				this.attendanceCountMonthName = ret.data.attendanceCountMonthName
				this.attendanceCountMonthValue = ret.data.attendanceCountMonthValue
				this.attendanceRate = ret.data.attendanceRate

				this.loadStudentDay()
				this.loadStudentMonth()
				setInterval(() => {
					this.handleTime()
				}, 1000)
			},
			handleTime() {
				const date = new Date(this.screen.time * 1000);
				const YY = date.getFullYear() + '-';
				const MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
				const DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
				const hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
				const mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
				const ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
				this.date = YY + MM + DD
				this.time = hh + mm + ss
				switch (date.getDay()) {
					case 0:
						this.week = this.$t('device.sunday');
						break;
					case 1:
						this.week = this.$t('device.monday');
						break;
					case 2:
						this.week = this.$t('device.tuesday');
						break;
					case 3:
						this.week = this.$t('device.wednesday');
						break;
					case 4:
						this.week = this.$t('device.thursday');
						break;
					case 5:
						this.week = this.$t('device.friday');
						break;
					case 6:
						this.week = this.$t('device.saturday');
						break;
				}
				this.screen.time++
			},
			loadStudentDay() {
				let myEchart = echarts.init(this.$refs.studentDay);

				// 将数据按每两个点分组
				const groupedData = this.attendanceCountListValue.reduce((acc, value, index) => {
					const groupIndex = Math.floor(index / 2);
					if (!acc[groupIndex]) acc[groupIndex] = [];
					acc[groupIndex].push(value);
					return acc;
				}, []);

				// 生成X轴标签（每组一个标签）
				const xAxisData = groupedData.map((_, i) => this.attendanceCountListName[i] || `组${i+1}`);

				// 提取每组的第一个值（蓝色柱子）
				const blueData = groupedData.map(group => group[0] || 0);

				// 提取每组的第二个值（红色柱子）
				const redData = groupedData.map(group => group[1] || 0);

				const option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					xAxis: {
						type: 'category',
						data: xAxisData,
						axisLabel: {
							formatter: '{value}',
							textStyle: {
								color: "#fff",
								fontSize: 16,
							}
						},
					},
					yAxis: {
						type: 'value',
						min: 0, // 设置Y轴最小值为0
						max: 40, // 设置Y轴最大值为60
						interval: 5, // 设置刻度间隔为10
						axisLabel: {
							showMinLabel: true, // 强制显示最小刻度标签
							showMaxLabel: true, // 强制显示最大刻度标签
							formatter: '{value}',
							textStyle: {
								color: "#fff",
								fontSize: 16,
							}
						},
					},
					grid: {
						left: '0%',
						right: '4%',
						bottom: '1%',
						containLabel: true
					},
					series: [{
							name: '蓝色柱',
							type: 'bar',
							//barCategoryGap: '20%', // 类目间距（组间）
							barGap: '0%', // 系列间距（组内）
							barWidth: 45, // 限制最大宽度为50像素
							data: blueData,
							itemStyle: {
								color: '#5470C6'
							}
						},
						{
							name: '红色柱',
							type: 'bar',
							//barCategoryGap: '20%', // 类目间距（组间）
							barGap: '0%', // 系列间距（组内）
							barWidth: 45, // 限制最大宽度为50像素
							data: redData,
							itemStyle: {
								color: '#FF0000'
							}
						}
					]
				};

				myEchart.setOption(option);

				// 添加窗口大小变化时的重绘
				window.addEventListener('resize', () => {
					myEchart.resize();
				});
			},

			loadStudentMonth() {
				const myEchart = echarts.init(this.$refs.studentMonth);
				const option = {
					color: ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'],
					// title: {
					//   text: 'Gradient Stacked Area Chart'
					// },
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							label: {
								backgroundColor: '#6a7985'
							}
						}
					},
					grid: {
						left: '1%',
						right: '1%',
						bottom: '1%',
						top: '5%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						data: this.attendanceCountMonthName
					}],
					yAxis: [{
						type: 'value',
						axisLabel: {
							color: '#ffffff' // 设置Y轴刻度标签颜色为白色
						}
					}],
					series: [{
						name: '缺勤人数',
						type: 'line',
						stack: 'Total',
						smooth: true,
						lineStyle: {
							width: 0
						},
						showSymbol: false,
						areaStyle: {
							opacity: 0.8,
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: 'rgb(128, 255, 165)'
								},
								{
									offset: 1,
									color: 'rgb(1, 191, 236)'
								}
							])
						},
						emphasis: {
							focus: 'series'
						},
						data: this.attendanceCountMonthValue
					}]
				};
				myEchart.setOption(option);
			}

		}
	};
</script>
<style scoped lang="css" src="../assets/screen/common.css" />
<style scoped lang="css" src="../assets/screen/index.css" />
<style>
	html,
	body {
		margin: 0;
		padding: 0;
		width: 100%;
		height: 100%;
		font-size: 14px;
		overflow: hidden !important;
	}

	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
		transform-origin: 0 0;
		width: 1920px !important;
		height: 1080px !important;
	}
</style>